module.exports = __webpack_public_path__ + "media/components/atoms/Logo/circle-checked-d60776cd986a87802edb8ade8093d988.svg";